import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appGetAllPost } from '../../store/post'
import { postExportColumns } from '../../config/exportColumns/postExportColumns'

function Post() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Posts</div>

					<div className="d-flex gap-2">
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllPost({
										...params,
										...exportFilters,
										hub: hubId || permissionOfHub,
										limit: 10000,
										loading: false,
									}),
								)
							}
							columns={postExportColumns}
							fileName="Posts"
							sheetName="Post List"
							buttonText="Export Posts"
						/>

						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/post/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Post
						</button>
					</div>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default Post
